/**
 * Production typography primitives (Phase 11.5.7 — literal realDemo clone). Eyebrow renders
 * the reference's decorative info line (`.landing-info-line`: an 85×3px bar; NO label — the
 * reference info has no eyebrow text). Heading = semantic h1/h2/h3/h4. Text = body paragraph.
 * Colors/sizes come from foundation.css (the scoped reference tokens); these own structure.
 */
import type { ElementType, ReactNode } from 'react'
import { cx } from './utils'

/** The reference "info line" — a short decorative bar above the heading (no text label). */
export function Eyebrow({ className }: { readonly children?: ReactNode; readonly className?: string }) {
  return <span className={cx('sbp-info__line', className)} aria-hidden="true" />
}

interface HeadingProps {
  readonly level: 1 | 2 | 3 | 4
  readonly id?: string
  readonly className?: string
  readonly children: ReactNode
}

export function Heading({ level, id, className, children }: HeadingProps) {
  const Tag = `h${level}` as ElementType
  return (
    <Tag id={id} className={cx('sbp-heading', `sbp-heading--${level}`, className)}>
      {children}
    </Tag>
  )
}

interface TextProps {
  readonly variant?: 'body' | 'lead' | 'muted'
  readonly as?: 'p' | 'span' | 'div'
  readonly className?: string
  readonly children: ReactNode
}

export function Text({ variant = 'body', as = 'p', className, children }: TextProps) {
  const Tag = as as ElementType
  return (
    <Tag
      className={cx('sbp-text', variant === 'lead' && 'sbp-text--lead', variant === 'muted' && 'sbp-text--muted', className)}
    >
      {children}
    </Tag>
  )
}
